import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-文档列表",
  "use": "icon-文档列表-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-文档列表\"><path d=\"M128 128v768h768V128H128z m853.333333-85.333333v938.666666H42.666667V42.666667h938.666666z\" p-id=\"2643\" /><path d=\"M213.333333 341.333333V256h256v85.333333zM213.333333 554.666667v-85.333334h597.333334v85.333334zM213.333333 768v-85.333333h426.666667v85.333333z\" p-id=\"2644\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol